import clsx from "clsx";

export interface CardProps {
  children: React.ReactNode;
  data?: object;

  cardStyle?: "primary" | "mobile" | "secondary" | "ghost" | "outline" | "dark";
  align?: string;
  cardSize?: "none" | "sm" | "base" | "md" | "lg" | "huge";
  width?: string;
  height?: string;
  action?: () => void;
  gap?: string;
  className?: string;
}

export function Card(props: CardProps) {
  const {
    children,
    width,
    height,
    cardStyle = "primary",
    cardSize,
    action,
    gap = "gap-6",
    className,
    align,
  } = props;

  const cardStyles = {
    primary: "bg-primary-white flex",
    mobile: "bg-primary-white flex flex-col",

    secondary: "bg-primary-white flex flex-col",
    ghost: "bg-transparent",
    outline: "bg-white border border-gray-light",
    dark: "bg-dark-video",
  };

  const cardSizes = {
    none: "p-0",
    sm: "p-4",
    base: "p-6",
    md: "p-8",
    lg: "md:p-20 xs:p-8 sm:p-12",
    huge: "p-24",
  };

  const classNames = className
    ? className
        .split(" ")
        .map((name) => name)
        .join(" ")
    : "";

  return (
    <div
      className={clsx(
        cardStyle && cardStyles[cardStyle],
        cardSize && cardSizes[cardSize],
        align,
        gap,
        width,
        height,
        classNames
      )}
      onClick={action}
    >
      {children}
    </div>
  );
}

export default Card;
